import { render, staticRenderFns } from "./CommonEditProject.vue?vue&type=template&id=e66dc1d4"
import script from "./CommonEditProject.vue?vue&type=script&lang=js"
export * from "./CommonEditProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports